import { scopeTypes } from '../../../core/js/constants';
import { getTargetedProduct } from '../../../product/js/utils/utils';

export function getAddToRegistryRoute(state, entity) {
    return {
        entity,
        method: 'POST',
        path: `${getBaseRegistryUri(state)}/${state.registry.selectedRegistry.id}/items?upsert=true`,
        scope: scopeTypes.AUTHORIZED
    };
}

function getBaseRegistryUri(state) {
    return `${state.core.constants.urls.registry}/${state.core.siteId}`;
}

export function getRegistriesRoute(state) {
    const profileId = state.core.profile.profileId;
    return {
        method: 'GET',
        path: `${getBaseRegistryUri(state)}/search?web_profile_id=${profileId}`,
        scope: scopeTypes.AUTHORIZED
    };
}

export function getRemoveFromRegistryRoute(state, entity) {
    const product = getTargetedProduct(state);
    const registryId = product.productRegistry.registry.id;
    const skuId = product.productRegistry.selectedItem.sku;
    return {
        entity,
        method: 'delete', // This lower case delete is needed for ie11 unfortunately.
        path: `${getBaseRegistryUri(state)}/${registryId}/items/${skuId}`,
        scope: scopeTypes.AUTHORIZED
    };
}

export function getUpdateRegistryItemQuantityRoute(state, entity) {
    const product = getTargetedProduct(state);
    const registryId = product.productRegistry.registry.id;
    const registrySlug = state.core.constants.urls.registry;
    const siteId = state.core.constants.siteId;
    const sku = product.productRegistry.selectedItem.sku;

    return {
        entity,
        method: 'PATCH',
        path: `${registrySlug}/${siteId}/${registryId}/items/${sku}`,
        scope: scopeTypes.AUTHORIZED
    };
}

export function getUpdateRegistryItemRoute(state, entity) {
    const product = getTargetedProduct(state);
    const registryId = product.productRegistry.registry.id;
    const registrySlug = state.core.constants.urls.registry;
    const siteId = state.core.constants.siteId;

    return {
        entity,
        method: 'POST',
        path: `${registrySlug}/${siteId}/${registryId}/items?upsert=true`,
        scope: scopeTypes.AUTHORIZED
    };
}
